export default __webpack_public_path__ + "static/media/0xa1428174f516f527fafdd146b883bb4428682737.eb69a105.webp";